import { render, staticRenderFns } from "./Blackjack.vue?vue&type=template&id=85ba6784&scoped=true"
import script from "./Blackjack.vue?vue&type=script&lang=js"
export * from "./Blackjack.vue?vue&type=script&lang=js"
import style0 from "./Blackjack.vue?vue&type=style&index=0&id=85ba6784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ba6784",
  null
  
)

export default component.exports